const DEFAULT_FILTERS = {
  hasAudio: false
}

function normalizeFilters (filters) {
  return Object.assign({}, DEFAULT_FILTERS, filters || {})
}

function extraFiltersTags (filters) {
  const applied = normalizeFilters(filters)
  const tags = []

  if (applied.hasAudio) {
    tags.push('audio')
  }

  return tags
}

export default {
  name: 'bus-stops-extra-filters',
  props: {
    filters: Object
  },
  data () {
    return {
      modalOpen: false,
      localFilters: normalizeFilters(this.filters)
    }
  },
  computed: {
    tags () {
      return extraFiltersTags(this.filters)
    }
  },
  watch: {
    filters: {
      handler (value) {
        if (!this.modalOpen) {
          this.localFilters = normalizeFilters(value)
        }
      },
      deep: true
    }
  },
  methods: {
    openFilters () {
      this.localFilters = normalizeFilters(this.filters)
      this.modalOpen = true
    },
    applyFilters () {
      this.$emit('apply', normalizeFilters(this.localFilters))
      this.modalOpen = false
    },
    clearFilters () {
      this.localFilters = normalizeFilters()
      this.$emit('apply', this.localFilters)
      this.modalOpen = false
    }
  }
}

export {
  DEFAULT_FILTERS,
  normalizeFilters,
  extraFiltersTags
}
